import { create } from 'zustand';

import type {
  ToolSurfaceCameraStoreActions,
  ToolSurfaceCameraStoreState,
} from '@/type';

const initState: ToolSurfaceCameraStoreState = {
  cameraMap: {
    front: {
      zoom: 70,
    },
    side: {
      zoom: 70,
    },
    top: {
      zoom: 70,
    },
  },
};

const useToolSurfaceCameraStore = create<
  ToolSurfaceCameraStoreState & ToolSurfaceCameraStoreActions
>((set, get) => {
  return {
    ...initState,

    getZoom(camera) {
      return (get().cameraMap as any)[camera].zoom;
    },

    setZoom(camera, zoom) {
      set({
        cameraMap: {
          ...get().cameraMap,
          [camera]: {
            zoom,
          },
        },
      });
    },
  };
});

export default useToolSurfaceCameraStore;
